import { render } from "./Result.vue?vue&type=template&id=4ce4e458"
import script from "./Result.vue?vue&type=script&lang=js"
export * from "./Result.vue?vue&type=script&lang=js"
script.render = render

export default script